import { registerSingleton } from '../../../platform/instantiation/common/extensions.js';
import { IExtHostExtensionService } from '../common/extHostExtensionService.js';
import { ExtensionStoragePaths, IExtensionStoragePaths } from '../common/extHostStoragePaths.js';
import { ExtHostExtensionService } from './extHostExtensionService.js';
registerSingleton(IExtHostExtensionService, ExtHostExtensionService, 0 );
registerSingleton(IExtensionStoragePaths, ExtensionStoragePaths, 0 );
